import React, { useEffect, useState } from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SimpleDropdown from "../../../../../../components/dropdowns/simple-dropdown";
import { eventBufferTimeHoursOptions, eventBufferTimeMinutesOptions, eventTimeTypeOptions, infoTextMessages } from "../../constants";

export default function BufferTimeEventDropdown(props) {
  // duration
  const [eventTimeType, setEventTimeType] = useState({ value: "hours", label: "Hours" });
  const [eventTime, setEventTime] = useState({ value: 0, label: "0" });

  useEffect(() => {
    if (props.value) {
      const data = eventBufferTimeHoursOptions.find((each) => each.duration === props.value);
      if (data) {
        setEventTimeType({ value: "hours", label: "Hours" });
        setEventTime(data);
      } else {
        const data2 = eventBufferTimeMinutesOptions.find((each) => each.duration === props.value);
        if (data2) {
          setEventTimeType({ value: "minutes", label: "Minutes" });
          setEventTime(data2);
        }
      }
    }
  }, [props.value]);

  const handleEventTypeChange = (data) => {
    setEventTimeType(data);
    setEventTime({ value: 0, label: "0" });
    props.setValue(0);
  };

  const handlEventTimeSelection = (data) => {
    props.setValue(data.duration);
  };

  return (
    <Form.Group>
      <Form.Label>
        Buffer Time
        <OverlayTrigger placement="right" overlay={<Tooltip>{infoTextMessages.BUFFER_TIME}</Tooltip>}>
          <i className="ml-2 bi bi-info-circle"></i>
        </OverlayTrigger>
      </Form.Label>
      <Row>
        <Col>
          <SimpleDropdown
            value={eventTime}
            label={"Select"}
            options={eventTimeType.value === "hours" ? eventBufferTimeHoursOptions : eventBufferTimeMinutesOptions}
            handleSelect={(data) => handlEventTimeSelection(data)}
          />
        </Col>
        <Col>
          <SimpleDropdown value={eventTimeType} label={"Select"} options={eventTimeTypeOptions} handleSelect={(a) => handleEventTypeChange(a)} />
        </Col>
      </Row>
    </Form.Group>
  );
}
